import React, { RefObject } from 'react';
import { Grid, Divider, List } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import EnableUserSelect from 'components/EnableUserSelect';
import HarvestEventEntityPathNamesReversedValue from 'components/HarvestEventEntityPathNamesReversedValue';
import RoleButtonLink from 'components/RoleButtonLink';
import EventEntityTotalBins from 'components/EventEntityTotalBins';
import HarvestEventAssignedGroupsList from 'components/HarvestEventAssignedGroupsList';
import HarvestEventErrorMessage from 'components/HarvestEventErrorMessage';
import HarvestEventPickTypeNameValue from 'components/HarvestEventPickTypeNameValue';
import HarvestEventVarietyNameValue from 'components/HarvestEventVarietyNameValue';
import SemiBold from 'components/SemiBold';

// Global Constants
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

interface Props {
    harvestEventUuid?: string;
}

class EventsTimelineEventDetails extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { harvestEventUuid } = this.props;

        if (!harvestEventUuid) {
            return null;
        }

        return (
            <div>
                <EnableUserSelect>
                    <HarvestEventErrorMessage
                        harvestEventUuid={harvestEventUuid}
                    />
                    <List>
                        <List.Item>
                            <List.Content floated="right">
                                <RoleButtonLink
                                    requiredRoles={[
                                        ADMIN,
                                        MANAGER,
                                        ASSISTANT_MANAGER
                                    ]}
                                    params={{
                                        seasonalEventModal: 'edit',
                                        selectedEvent: harvestEventUuid,
                                        eventPopup: undefined,
                                        selectedGroup: undefined
                                    }}
                                    buttonProps={{
                                        primary: true
                                    }}
                                >
                                    Edit
                                </RoleButtonLink>
                            </List.Content>
                            <List.Content>
                                <SemiBold>
                                    <React.Fragment>
                                        <HarvestEventPickTypeNameValue
                                            harvestEventUuid={harvestEventUuid}
                                        />
                                        {', '}
                                        <HarvestEventVarietyNameValue
                                            harvestEventUuid={harvestEventUuid}
                                        />
                                    </React.Fragment>
                                </SemiBold>
                            </List.Content>
                        </List.Item>
                        <List.Item>
                            <List.Content>
                                <SemiBold>
                                    <HarvestEventEntityPathNamesReversedValue
                                        harvestEventUuid={harvestEventUuid}
                                    />
                                </SemiBold>
                            </List.Content>
                        </List.Item>
                    </List>
                    <Divider section />
                    <HarvestEventAssignedGroupsList
                        harvestEventUuid={harvestEventUuid}
                        withDivider
                    />
                    <EventEntityTotalBins harvestEventUuid={harvestEventUuid} />
                    <Divider section />
                    <Grid>
                        <Grid.Row>
                            <Grid.Column>
                                <RoleButtonLink
                                    requiredRoles={[
                                        ADMIN,
                                        MANAGER,
                                        ASSISTANT_MANAGER
                                    ]}
                                    params={{
                                        selectedEvent: harvestEventUuid,
                                        eventPopup: undefined,
                                        unscheduleEventModal: true,
                                        selectedGroup: undefined
                                    }}
                                    buttonProps={{
                                        primary: true
                                    }}
                                >
                                    Unschedule
                                </RoleButtonLink>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </EnableUserSelect>
            </div>
        );
    }
}

export default EventsTimelineEventDetails;
